import React, { useState, useEffect, useCallback } from 'react';
import {
  IonRow,
  IonSelect,
  IonSelectOption,
  IonButton,
  IonCol,
} from '@ionic/react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import { Button, TableSortLabel } from '@material-ui/core';
import moment, { Moment } from 'moment';
import MomentUtils from '@date-io/moment';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { useLocation } from 'react-router';
import { connect } from 'react-redux';

import API from '../../api/index';
import { UserBet } from '../../models/UserBet';
import Spinner from '../Spinner/Spinner';
import {
  MarketTypeByEnumMap,
  MarketTypeMap,
  oddValueFormatter,
  OutcomeDescByEnumMap,
  OutcomeDescMap,
  outcomeNameFormatter,
} from '../../util/stringUtil';
import { getCurrencyTypeFromToken } from '../../store';
import { RootState } from '../../models/RootState';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import CompetitionsMenu from '../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import { getSportNameByIdMap } from '../../util/stringUtil';
import './MyBets.scss';
import REPORTING_API from '../../api-services/reporting-api';

type StoreProps = {
  allowedConfig: number;
};

const MyBets: React.FC<StoreProps> = (props) => {
  const [bets, setBets] = useState<UserBet[]>([]);
  const [sportFilter, setSportFilter] = useState<string>('all');

  const [games, setGames] = useState<string>('all');
  const [filter, setFilter] = useState<string>('Open');
  const [currpage, setcurrpage] = useState<number>(1);
  const [dataflag, setdataflag] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [sortDesc, setsortDesc] = useState<boolean>(true);
  const [dateFrom, setDateFrom] = useState<Moment>(moment().subtract(7, 'd'));
  const [dateTo, setDateTo] = useState<Moment>(moment());
  const pageSize = 25;
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  const [pageToken, setPageToken] = useState<string[]>(['']);
  const [nextPageToken, setNextPageToken] = useState<string>('');

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search).get('status');
  const { allowedConfig } = props;

  useEffect(() => {
    if (searchParams) {
      setFilter(searchParams);
    }
  }, [searchParams]);

  const gameHandler = (game: string) => {
    setGames(game);
    setLoading(true);
    setcurrpage(1);
    setPageToken(['']);
  };

  const filterHandler = (filter: string) => {
    if (filter === 'unmatched' || filter === 'lapsed') {
      setGames('SPORTS');
    }
    setFilter(filter);
    setLoading(true);
    setcurrpage(1);
    setPageToken(['']);
  };

  const nextpageHandler = () => {
    setLoading(true);
    setcurrpage(currpage + 1);
  };

  const prevpageHandler = () => {
    setLoading(true);
    setcurrpage(currpage - 1);
  };

  const nextPage = () => {
    setLoading(true);
    setcurrpage(currpage + 1);
    if (nextPageToken) {
      setPageToken([...pageToken, nextPageToken]);
    }
  };

  const prevPage = () => {
    setLoading(true);
    setcurrpage(currpage - 1);
    if (pageToken.length > 1) {
      let pagetokens = pageToken;
      pagetokens.pop();
      setPageToken([...pagetokens]);
    }
    setLoading(false);
  };

  const sortOrderHandler = () => {
    setLoading(true);
    setsortDesc(!sortDesc);
  };

  useEffect(() => {
    let secTimer = setInterval(() => { }, 10000);

    return () => clearInterval(secTimer);
  }, []);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const response = await REPORTING_API.get('reports/v2/orders/:search', {
      headers: {
        Authorization: sessionStorage.getItem('jwt_token'),
        Accept: 'application/json',
      },
      params: {
        reportType: 'ORDER_LIST',

        categoryType:
          filter === 'unmatched' ? '-' : games === 'all' ? null : games,
        status:
          filter === 'unmatched'
            ? 'Unmatched'
            : filter === 'All'
              ? null
              : filter,
        sportId: games === 'SPORTS' && sportFilter !== "all" ? sportFilter : null,

        // pageNum: currpage,
        sortOrder: sortDesc ? 'DESC' : 'ASC',
        pageSize: pageSize,
        startDate: dateFrom.startOf('day').toISOString(),
        endDate: dateTo.endOf('day').toISOString(),
        pageToken: pageToken[pageToken.length - 1],

        // currencyType: null,
      },
    });
    let betList = response.data?.orders;
    for (const bet of betList) {
      bet.stakeAmount = bet.stakeAmount / cFactor;
      bet.payOutAmount = bet.payOutAmount / cFactor;
    }
    setBets([]);
    setBets(betList);
    setNextPageToken(response.data?.pageToken);
    setdataflag(1);
    setLoading(false);
  }, [
    pageToken,
    filter,
    sportFilter,
    games,
    sortDesc,
    dateFrom,
    dateTo,
    cFactor,
  ]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onSportFilterChange = (sport: string) => {
    setSportFilter(sport);
  };

  return (
    <div className="report-page">
      <IonRow>
        <IonCol sizeMd="1.7" sizeLg="1.7" className="web-view">
          <div className="compt-menu-section">
            <div className="sticky-col">
              <CompetitionsMenu loggedIn={true} />
            </div>
          </div>
        </IonCol>
        <IonCol sizeXs="12" sizeSm="12" sizeMd="10.3" sizeLg="10.3">
          <div className="reports-ctn my-bets-ctn">
            <div className="carw">
              <div className="arrow arrow-right">My Bets</div>
            </div>

            <IonRow className="filters-row">
              <IonCol sizeXs="12" sizeSm="12" sizeMd="12" sizeLg="12">
                <div className="filter-title">Filter your bets:</div>
              </IonCol>
              <IonCol sizeXs="6" sizeSm="6" sizeMd="3" sizeLg="3">
                <div className="select-filter">
                  <IonSelect
                    className="select-filter-control"
                    value={filter}
                    placeholder="Select One"
                    interface="popover"
                    onIonChange={(e) => filterHandler(e.detail.value)}
                  >
                    <IonSelectOption value="All">All</IonSelectOption>
                    <IonSelectOption value="Open">Open</IonSelectOption>
                    <IonSelectOption value="Settled">Settled</IonSelectOption>
                    <IonSelectOption value="Won">Won</IonSelectOption>
                    <IonSelectOption value="Lost">Lost</IonSelectOption>
                    <IonSelectOption value="Voided">Void</IonSelectOption>
                  </IonSelect>
                </div>
              </IonCol>
              <IonCol sizeXs="6" sizeSm="6" sizeMd="3" sizeLg="3">
                <div className="select-filter">
                  <IonSelect
                    value={games}
                    className="select-filter-control"
                    placeholder="Select One"
                    interface="popover"
                    onIonChange={(e) => gameHandler(e.detail.value)}
                  >
                    <IonSelectOption value="all">All</IonSelectOption>
                    {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
                      <IonSelectOption value="SPORTS">Sports</IonSelectOption>
                    ) : null}
                    {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
                      <IonSelectOption value="SPORTS_BOOK">
                        Sportsbook
                      </IonSelectOption>
                    ) : null}
                    <IonSelectOption value="PREMIUM">Premium</IonSelectOption>
                    {/* {(allowedConfig & CONFIG_PERMISSIONS.cricket) !== 0 ? (
                      <IonSelectOption value="binary">Binary</IonSelectOption>
                    ) : null} */}
                    {(allowedConfig & CONFIG_PERMISSIONS.live_casino) !== 0 ? (
                      <IonSelectOption value="CASINO">Casino</IonSelectOption>
                    ) : null}
                    {(allowedConfig & CONFIG_PERMISSIONS.indian_casino) !==
                      0 ? (
                      <IonSelectOption value="INDIAN_CASINO">
                        Indian Casino
                      </IonSelectOption>
                    ) : null}
                  </IonSelect>
                </div>
              </IonCol>
              <IonCol sizeXs="6" sizeSm="6" sizeMd="3" sizeLg="3">
                <div className="date-filter">
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                      disableFuture
                      className="date-filter-control"
                      InputProps={{
                        disableUnderline: true,
                        readOnly: true,
                      }}
                      disableToolbar
                      autoOk={true}
                      variant="inline"
                      format="DD/MM/yyyy"
                      margin="normal"
                      minDate={moment().subtract(1, 'months').calendar()}
                      id="date-picker-inline"
                      value={dateFrom ? dateFrom : null}
                      onChange={(e) => {
                        if (e == null) {
                          setLoading(true);
                          setDateFrom(null);
                          setPageToken(['']);
                        } else {
                          setLoading(true);
                          setDateFrom(e);
                          setPageToken(['']);
                        }
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </IonCol>{' '}
              <IonCol sizeXs="6" sizeSm="6" sizeMd="3" sizeLg="3">
                <div className="date-filter">
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                      disableFuture
                      className="date-filter-control"
                      InputProps={{
                        disableUnderline: true,
                        readOnly: true,
                      }}
                      disableToolbar
                      autoOk={true}
                      variant="inline"
                      format="DD/MM/yyyy"
                      margin="normal"
                      minDate={moment().subtract(1, 'months').calendar()}
                      id="date-picker-inline"
                      value={dateTo ? dateTo : null}
                      disabled={dateFrom ? false : true}
                      onChange={(e) => {
                        if (e == null) {
                          setLoading(true);
                          setDateTo(null);
                          setPageToken(['']);
                        } else {
                          setLoading(true);
                          setDateTo(e);
                          setPageToken(['']);
                        }
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </IonCol>
            </IonRow>

            <div className="ion-btns sports-filters-row">
              {games === 'SPORTS' ? (
                <>
                  {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
                    <Button
                      variant="outlined"
                      className={sportFilter === 'all' ? 'primary' : ''}
                      onClick={() => onSportFilterChange('all')}
                    >
                      All
                    </Button>
                  ) : null}
                  {(allowedConfig & CONFIG_PERMISSIONS.cricket) !== 0 ? (
                    <Button
                      variant="outlined"
                      className={sportFilter === '4' ? 'primary' : ''}
                      onClick={() => onSportFilterChange('4')}
                    >
                      Cricket
                    </Button>
                  ) : null}
                  {(allowedConfig & CONFIG_PERMISSIONS.football) !== 0 ? (
                    <Button
                      variant="outlined"
                      className={sportFilter === '1' ? 'primary' : ''}
                      onClick={() => onSportFilterChange('1')}
                    >
                      Football
                    </Button>
                  ) : null}
                  {(allowedConfig & CONFIG_PERMISSIONS.tennis) !== 0 ? (
                    <Button
                      variant="outlined"
                      className={sportFilter === '2' ? 'primary' : ''}
                      onClick={() => onSportFilterChange('2')}
                    >
                      Tennis
                    </Button>
                  ) : null}
                  {(allowedConfig & CONFIG_PERMISSIONS.baseball) !== 0 ? (
                    <Button
                      variant="outlined"
                      className={sportFilter === '7511' ? 'primary' : ''}
                      onClick={() => onSportFilterChange('7511')}
                    >
                      Baseball
                    </Button>
                  ) : null}
                  {(allowedConfig & CONFIG_PERMISSIONS.basketball) !== 0 ? (
                    <Button
                      variant="outlined"
                      className={sportFilter === '7522' ? 'primary' : ''}
                      onClick={() => onSportFilterChange('7522')}
                    >
                      Basketball
                    </Button>
                  ) : null}
                  {(allowedConfig & CONFIG_PERMISSIONS.greyhoundracing) !==
                    0 ? (
                    <Button
                      variant="outlined"
                      className={sportFilter === '4339' ? 'primary' : ''}
                      onClick={() => onSportFilterChange('4339')}
                    >
                      Greyhound{' '}
                    </Button>
                  ) : null}

                  {(allowedConfig & CONFIG_PERMISSIONS.horseracing) !== 0 ? (
                    <Button
                      variant="outlined"
                      className={sportFilter === '7' ? 'primary' : ''}
                      onClick={() => onSportFilterChange('7')}
                    >
                      horseracing{' '}
                    </Button>
                  ) : null}
                </>
              ) : null}
            </div>

            <div className="myb-bets-div">
              {pageToken.length === 1 || loading ? null : (
                <IonButton
                  className="myb-btn-prev"
                  onClick={(e) => prevPage()}
                  disabled={pageToken.length < 2}
                >
                  Prev({pageToken.length - 1})
                </IonButton>
              )}
              {nextPageToken && !loading ? (
                <IonButton
                  className="myb-btn-next"
                  onClick={(e) => nextPage()}
                  disabled={!nextPageToken}
                >
                  Next({pageToken.length + 1})
                </IonButton>
              ) : null}
              {loading ? (
                <Spinner />
              ) : (
                <>
                  <TableContainer component={Paper}>
                    <Table className="myb-table">
                      <TableHead className="myb-table-header">
                        <TableRow>
                          <TableCell align="left">category</TableCell>
                          <TableCell className="th-date web-view">
                            Place Date
                            <IconButton
                              aria-label="Change Order"
                              size="medium"
                              onClick={() => sortOrderHandler()}
                            >
                              {sortDesc ? (
                                <TableSortLabel
                                  active={true}
                                  direction="desc"
                                />
                              ) : (
                                <TableSortLabel active={true} direction="asc" />
                              )}
                            </IconButton>
                          </TableCell>
                          <TableCell align="left" className="th-match">
                            Match
                          </TableCell>
                          <TableCell
                            className="th-match-date web-view"
                            align="left"
                          >
                            Match Date
                          </TableCell>
                          <TableCell
                            align="left"
                            className="th-market web-view"
                          >
                            Market
                          </TableCell>
                          <TableCell
                            align="left"
                            className="th-bet-on web-view"
                          >
                            Bet On
                          </TableCell>
                          <TableCell align="left">Odds</TableCell>
                          <TableCell align="left">Bet Type</TableCell>
                          <TableCell align="left">Stake</TableCell>
                          <TableCell
                            align="left"
                            className="th-outcome web-view"
                          >
                            Outcome
                          </TableCell>
                          <TableCell
                            align="left"
                            className="th-outcome web-view"
                          >
                            Bet status
                          </TableCell>
                          <TableCell align="left">Returns</TableCell>
                        </TableRow>
                        {/* </div> */}
                      </TableHead>
                      <TableBody>
                        {bets?.length > 0 ? (
                          bets.map((row) => <Row key={row.id} row={row} />)
                        ) : (
                          <TableRow>
                            <TableCell colSpan={10}>
                              <div className="no-bets-msg">
                                No records found
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
              {pageToken.length === 1 || loading ? null : (
                <IonButton
                  className="myb-btn-prev"
                  onClick={(e) => prevPage()}
                  disabled={pageToken.length < 2}
                >
                  Prev({currpage - 1})
                </IonButton>
              )}
              {nextPageToken && !loading ? (
                <IonButton
                  className="myb-btn-next"
                  onClick={(e) => nextPage()}
                  disabled={!nextPageToken}
                >
                  Next({currpage + 1})
                </IonButton>
              ) : null}
            </div>
          </div>
        </IonCol>{' '}
      </IonRow>
    </div>
  );
};

function Row(props: { row: UserBet }) {
  const { row } = props;

  const CalcReturns = (row: UserBet) => {
    if (row.marketType === 'MATCH_ODDS') {
      // RollBack/Void/Elapsed/cancled
      if (
        ['RolledBack', 'Voided', 'Lapsed', 'Cancelled'].includes(
          row.outcomeResult.toString()
        )
      ) {
        return row.betType === 'BACK'
          ? row.stakeAmount
          : (row.oddValue - 1) * row.stakeAmount;
      }

      // Lay Bet
      if (row.betType === 'LAY') {
        return row.outcomeResult === 'Won'
          ? row.stakeAmount
          : (1 - row.oddValue) * row.stakeAmount;
      }

      // Back Bet
      if (row.betType === 'BACK') {
        return row.outcomeResult === 'Won'
          ? (row.oddValue - 1) * row.stakeAmount
          : row.stakeAmount * -1;
      }
    }

    return row.stakeAmount;
  };

  return (
    <React.Fragment>
      <TableRow
        className={
          (row.oddValue && row.betType === 'BACK') || row.eventName === 'CASINO'
            ? 'back-bg'
            : row.oddValue && row.betType === 'LAY'
              ? 'lay-bg'
              : 'row-bg'
        }
      >
        <TableCell scope="row">
          <div className="bet-tag">
            {row.categoryType === 'SPORTS_BOOK' ? (
              <span className="text1">Sportsbook </span>
            ) : row.categoryType !== 'SPORTS_BOOK' &&
              row.marketType === 'PREMIUM' ? (
              <span className="text2">
                {' '}
                {MarketTypeByEnumMap[row?.marketType]}
              </span>
            ) : row.marketType === 'BINARY' || row.marketType === 'CASINO' ? (
              <span className="text3">Casino</span>
            ) : (
              <span className="text4">
                Sports ({getSportNameByIdMap(row?.sportId)})
              </span>
            )}
          </div>
        </TableCell>

        <TableCell component="th" scope="row" className="web-view">
          <div className="date">
            {' '}
            {moment(row.betPlacedTime).format('DD-MM-YY, h:mm:ss A')}
          </div>
        </TableCell>

        <TableCell className="myb-table-cell td-match" align="left">
          <div className="web-view badge-ctn ">
            <span className="event-link ">{row.eventName}</span>
          </div>

          <div className="mob-view">
            <div className="game-label col-data-header mob-fs-13">
              {row.eventName}
            </div>
            <div className="market-label col-data-header">
              Bet On:{' '}
              {outcomeNameFormatter(
                row.marketType,
                row.marketName,
                row.oddValue,
                row.outcomeDesc,
                row.sessionRuns
              )}
            </div>
            <div className="col-data-desc">
              {moment(row.betPlacedTime).format('DD-MM-YY, h:mm:ss A')}
            </div>
          </div>
        </TableCell>
        <TableCell
          className="myb-table-cell th-match-date web-view"
          align="left"
        >
          {row.eventDate
            ? moment(row.eventDate).format('DD-MM-YY, h:mm A')
            : null}{' '}
        </TableCell>
        <TableCell className="myb-table-cell td-market web-view " align="left">
          <span className="market-size ">
            {row.marketName ||
              MarketTypeByEnumMap[row.marketType] ||
              MarketTypeMap[row.marketType] ||
              '-'}
          </span>
        </TableCell>
        <TableCell className="myb-table-cell td-bet-on web-view" align="left">
          <span className="market-size ">
            {outcomeNameFormatter(
              row.marketType,
              row.marketName,
              row.oddValue,
              row.outcomeDesc,
              row.sessionRuns
            )}
          </span>
        </TableCell>
        <TableCell className="myb-table-cell td-odd" align="left">
          <span className="mob-fs-13">
            {oddValueFormatter(row.marketType, row.oddValue, row.sessionRuns)}
          </span>
        </TableCell>
        <TableCell className="myb-table-cell td-odd" align="left">
          <div
            className={
              row?.betType === 'BACK'
                ? 'back'
                : row?.betType === 'LAY'
                  ? 'lay'
                  : ''
            }
          >
            {row?.marketType === 'FANCY'
              ? row.betType === 'BACK'
                ? 'Yes'
                : 'No'
              : row.betType === 'BACK'
              ? 'Back'
              : 'Lay'}
          </div>
        </TableCell>

        <TableCell className="myb-table-cell td-stake" align="left">
          <span className="mob-fs-14">{Number(row.stakeAmount.toFixed(2)).toLocaleString('en-US')}</span>
        </TableCell>
        <TableCell className={'web-view'} align="left">
          -
        </TableCell>

        <TableCell className="myb-table-cell td-outcome web-view" align="left">
          {OutcomeDescByEnumMap[row.outcomeResult.toString()]
            ? OutcomeDescByEnumMap[row.outcomeResult.toString()]
            : 'Unsettled'}
        </TableCell>
        <TableCell
          className={
            row.payOutAmount > 0
              ? 'myb-table-cell profit-bet'
              : 'myb-table-cell loss-bet'
          }
          align="left"
        >
          <span className="mob-fs-14">
            {row.outcomeResult === 'Open' ? '-' : row.payOutAmount.toFixed(2)}
          </span>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const mapStateToProps = (state: RootState) => {
  return {
    allowedConfig: state.common.allowedConfig,
  };
};

export default connect(mapStateToProps, null)(MyBets);
